class DropdownPanel extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector("[data-dropdown-trigger]");
    this.panel = this.querySelector("[data-dropdown-panel]");
    this.#bindUI();
  }

  #bindUI() {
    this.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.panel.hasAttribute("data-open")) {
        e.preventDefault();
        this.closePanel();
        this.trigger.focus();
      }
    });
  }

  show() {
    this.panel.setAttribute("data-open", "true");
    this.trigger.setAttribute("aria-expanded", "true");
  }

  hide() {
    this.panel.setAttribute("data-open", "false");
    this.trigger.setAttribute("aria-expanded", "false");
  }
}

customElements.define("dropdown-panel", DropdownPanel);

export { DropdownPanel };
export default DropdownPanel;
